import { createBrowserRouter } from 'react-router-dom';
import { RequireAuth } from '@features/auth/components/RequireAuth';
import { RequireRole } from '@features/auth/components/RequireRole';

export const router = createBrowserRouter([
  // ── Layout Public (Header, Footer, etc.) ──
  {
    path: '/',
    lazy: () => import('@components/layout/PublicLayout'),
    children: [
      {
        index: true,
        lazy: () => import('@pages/public/Landing'),
      },

      {
        path: 'reservation/:id/attente',
        lazy: () => import('@pages/public/PaymentPending'),
      },
      {
        path: 'reserver',
        lazy: () => import('@pages/public/Booking'),
      },
    ],
  },

  // ── Auth ──
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        lazy: () => import('@pages/auth/Login'),
      },
      {
        path: 'otp',
        lazy: () => import('@pages/auth/Otp'),
      },
    ],
  },

  // ── Espaces Privés (Client & Admin) ──
  {
    element: <RequireAuth />,
    children: [
      // Espace Client
      {
        element: <RequireRole role="client" />,
        children: [
          {
            path: 'espace-client',
            lazy: () => import('@components/layout/ClientLayout'),
            children: [
              {
                index: true,
                lazy: () => import('@pages/client/MyReservations'),
              },
              {
                path: 'reservation/:id',
                lazy: () => import('@pages/client/ReservationDetail'),
              },
              {
                path: 'profil',
                lazy: () => import('@pages/client/Profile'),
              },
            ],
          },
        ],
      },

      // Espace
      {
        element: <RequireRole role="admin" />,
        children: [
          {
            path: 'admin',
            lazy: () => import('@components/layout/AdminLayout'),
            children: [
              {
                index: true,
                lazy: () => import('@pages/admin/Dashboard'),
              },
              {
                path: 'reservations',
                lazy: () => import('@pages/admin/Reservations'),
              },
              {
                path: 'local',
                lazy: () => import('@pages/admin/LocalSettings'),
              },
              {
                path: 'calendrier',
                lazy: () => import('@pages/admin/Calendar'),
              },
              {
                path: 'clients',
                lazy: () => import('@pages/admin/Clients'),
              },
              {
                path: 'finances',
                lazy: () => import('@pages/admin/Finances'),
              },
            ],
          },
        ],
      },
    ],
  },
]);
